export class RecommerceContentError extends Error {
  readonly message: string
  readonly type: string
  constructor(message: string) {
    super()
    this.type = 'RecommerceContentError'
    this.message = message
  }
}
